function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// typed-ember has not published types for this yet
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { createCache, getValue } from '@glimmer/tracking/primitives/cache';
import { getOwner, setOwner } from '@ember/application';
import { associateDestroyableChild, destroy } from '@ember/destroyable'; // typed-ember has not published types for this yet
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

import { capabilities as helperCapabilities, setHelperManager } from '@ember/helper';
export class Resource {
  static next(prev, args) {
    // TS does not infer subclass static types
    return new this(getOwner(prev), args, prev);
  }
  /**
   * @param {unknown} [owner] the application owner which allows service injections
   * @param {T} [args] both positional (array) and named (object) args
   * @param {Resource<T>} [previous] if the resource is being updated, this value will be the previous instance of the resource
   *
   */


  constructor(owner, args,
  /* eslint-disable @typescript-eslint/no-unused-vars */
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  previous) {
    this.args = args;
    setOwner(this, owner);
  }

}

class ResourceManager {
  constructor(owner) {
    _defineProperty(this, "capabilities", helperCapabilities('3.23', {
      hasValue: true,
      hasDestroyable: true
    }));

    this.owner = owner;
  }

  createHelper(Class, args) {
    let owner = this.owner;
    let instance;
    let cache = createCache(() => {
      let newInstance = new Class(owner, args, instance);
      associateDestroyableChild(cache, newInstance);
      if (instance) destroy(instance);
      instance = newInstance;
      return instance;
    });
    return cache;
  }

  getValue(cache) {
    let instance = getValue(cache);
    return instance;
  }

  getDestroyable(cache) {
    return cache;
  }

}

setHelperManager(owner => new ResourceManager(owner), Resource);